<template>
  <div class="modal-options rating-order">
    <div class="media mb-2">
      <el-image :src="order.location.logo.url" class="logo mr-2">
        <div slot="error" class="image-slot">
              <img class="photo" src="img/logo-error-200.png" />
            </div>
      </el-image>
      <div class="media-body">
        <h4 class="p-0 m-0 big-title" :style="{ color: myTheme.modalTextColor }">
          {{ order.location.name }}
        </h4>
        <p class="header-address">
          <i class="k-icon-location-pointer"></i>
          {{ getHelpers.generateFromatedAddress(order.location.address) }}
        </p>
      </div>
    </div>
    <template>
      <p class="big-title" :style="{ color: myTheme.modalTextColor }">
        {{
          $t("message.review_location_title", {
            location_name: order.location.name,
          })
        }}
      </p>
      <div class="food">
        <p class="medium-title">
          <i class="k-icon-menu2"></i>
          {{ $t("message.review_food_question_title") }}
        </p>
        <el-rate
          v-model="rating.food"
          :icon-classes="iconClassesLocation"
          void-icon-class="k-icon-rating"
          :texts="reviews_options"
          :show-text="true"
          :max="max"
          :colors="ratingIconColors"
        >
        </el-rate>
      </div>
      <el-divider></el-divider>
      <div class="service">
        <p class="medium-title">
          <i class="k-icon-food-1"></i>
          {{ $t("message.review_service_question_title") }}
        </p>
        <el-rate
          v-model="rating.service"
          :icon-classes="iconClassesLocation"
          void-icon-class="k-icon-rating"
          :texts="reviews_options"
          :show-text="true"
          :max="max"
          :colors="ratingIconColors"
        ></el-rate>
      </div>
      <el-divider></el-divider>
      <div class="deliver_collection">
        <p
          v-if="order.order_type == getEnumHelper.orderType.Delivery"
          class="medium-title"
        >
          <i class="k-icon-delivery-outline"></i>
          {{ $t("message.review_delivery_service") }}
        </p>
        <p
          v-else-if="order.order_type == getEnumHelper.orderType.Collection"
          class="medium-title"
        >
          <i class="k-icon-pick-up"></i>
          {{ $t("message.review_pickup_service") }}
        </p>
        <p v-else class="medium-title">
          <i class="k-icon-table-outline"></i>
          {{ $t("message.review_table_service") }}
        </p>
        <el-rate
          v-model="rating.delivery_collection"
          :icon-classes="iconClassesLocation"
          void-icon-class="k-icon-rating"
          :texts="reviews_options"
          :show-text="true"
          :max="max"
          :colors="ratingIconColors"
        ></el-rate>
      </div>
    </template>
    <el-divider></el-divider>
    <div class="option">
      <p>{{ $t("message.additional_comment") }}</p>
      <fg-textarea
        class="no-border"
        :placeholder="$t('input.placeholder.additional_comments')"
        addon-left-icon="now-ui-icons k-icon-comment"
        v-model="rating.comment"
        :maxlength="700"
      ></fg-textarea>
      <p class="textarea-info">
        {{ $t("text.remaining_characters", {count:700 - rating.comment.length}) }}
      </p>
      <p
        class="textarea-info error"
        v-if="rating.comment != '' && rating.comment.length < 25"
      >
        {{ $t("validation.provide_comment_min_characters") }}
      </p>
    </div>

    <el-divider></el-divider>
    <template>
      <p class="big-title" :style="{ color: myTheme.modalTextColor }">
        {{ $t("message.review_food") }}
      </p>
      <div v-for="(food, foodIndex) in order.orderItems" :key="foodIndex">
        <cards class="previews-order-card">
          <div class="food-rating-top">
            <div class="item-name">{{ food.item }}</div>
            <div class="item-price text-end">
              {{
                food.price.formatted
              }}
            </div>
            <div class="item-dietaries">{{ $t("text.dietaries") }}</div>
          </div>
          <div class="food-rating-bottom">
            <p class="small-title" :style="{ color: myTheme.modalTextColor }">
              {{ $t("text.your_rating") }}
            </p>
            <el-rate
              v-model="food.rating"
              :icon-classes="iconClassesStars"
              void-icon-class=" k-icon-forkstar"
              :texts="['1', '2', '3', '4', '5', '6', '7']"
              :show-text="true"
              :max="max"
              :colors="ratingIconColors"
            ></el-rate>
          </div>
        </cards>
      </div>
    </template>

    <div class="pull-right">
      <n-button type="success" @click.native="saveOrderReview()" :style="[myTheme.servicesButton.active]">
        {{ $t("button.save_review") }}
      </n-button>
      <n-button type="default" @click.native="cancelOrderReview()">{{
        $t("button.cancel")
      }}</n-button>
    </div>
  </div>
</template>
<script>
import { Button, Cards, FormTexterea } from "@/components";
import { helpers, enumHelper } from "@/utilities";
import staticColors from "@/model/colors";

export default {
  name: "order-review",
  components: {
    [Button.name]: Button,
    Cards,
    [FormTexterea.name]: FormTexterea,
  },
  props: {
    order: Object,
  },
  data() {
    return {
      getHelpers: helpers,
      iconClassesLocation: [
        "k-icon-rating",
        "k-icon-rating",
        "k-icon-rating",
        "k-icon-rating",
        "k-icon-rating",
        "k-icon-rating",
        "k-icon-rating",
      ],
      iconClassesStars: [
        "k-icon-forkstar",
        "k-icon-forkstar",
        "k-icon-forkstar",
        "k-icon-forkstar",
        "k-icon-forkstar",
        "k-icon-forkstar",
        "k-icon-forkstar",
      ],
      max: 7,
      rating: {
        comment: "",
        food: 0,
        service: 0,
        delivery_collection: 0,
      },
      reviews_options: [
        this.$t("reviews.forking_awful"),
        this.$t("reviews.forking_awful"),
        this.$t("reviews.forking_awful"),
        this.$t("reviews.forking_okay"),
        this.$t("reviews.forking_okay"),
        this.$t("reviews.forking_okay"),
        this.$t("reviews.forking_awesome"),
      ],
      getEnumHelper: enumHelper,
      ratingIconColors: [
        "#99A9BF",
        staticColors.ratingOkey,
        staticColors.ratingGood,
      ],
    };
  },
  methods: {
    saveOrderReview() {
      if (!this.checkRequiredRating()) {
        this.$message.error(this.$t("validation.review_verification_message"));
        return;
      }
      if (this.rating.comment != "" && this.rating.comment.length < 25) {
        return;
      }
      //--- get the rating data
      let objRating = {
        order_id: this.order.id,
        food_rating: this.rating.food,
        service_rating: this.rating.service,
        collection_delivery_rating: this.rating.delivery_collection,
        content: this.rating.comment,
        order_items: helpers.generateMenuItemRating(this.order.orderItems),
      };

      this.$emit("onSaveOrderReview", {
        order: this.order,
        rating: objRating,
        save: true,
      });
    },
    cancelOrderReview(){
      this.$emit('onCancelOrderReview')
    },
    checkRequiredRating() {
      return (
        this.rating.food &&
        this.rating.service &&
        this.rating.delivery_collection
      );
    },
  },
};
</script>
<style scoped>
.form-group.input-group {
  padding: 0px;
}
</style>
